import { render } from "./Issuance.vue?vue&type=template&id=232f9234"
import script from "./Issuance.vue?vue&type=script&lang=js"
export * from "./Issuance.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__